var _g, _path, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvanceIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_75_6850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3804 8.20435C9.71985 8.40013 10.1039 8.50248 10.4945 8.50122C10.8851 8.49997 11.2686 8.39516 11.6068 8.19721C11.945 7.99926 12.2262 7.71506 12.4224 7.37286C12.6187 7.03066 12.7231 6.64237 12.7254 6.24659H14.9754C14.9775 6.64259 15.0819 7.03113 15.2783 7.37354C15.4746 7.71595 15.756 8.0003 16.0944 8.19829C16.4329 8.39629 16.8166 8.50103 17.2074 8.50209C17.5982 8.50315 17.9824 8.4005 18.3219 8.20435L19.4469 10.1773C20.0724 9.82315 20.8209 9.58907 21.5829 9.45075C21.5369 9.31395 21.4769 9.18019 21.4029 9.04947L20.2644 7.05371C19.97 6.53581 19.4855 6.15683 18.9165 5.99938C18.3475 5.84193 17.7402 5.91877 17.2269 6.21315C17.2218 5.61539 16.9836 5.04394 16.5644 4.62338C16.1451 4.20283 15.5788 3.96729 14.9889 3.96811H12.7149C11.4849 3.96811 10.4874 4.97131 10.4769 6.21467C9.96345 5.91981 9.35576 5.8427 8.78642 6.00018C8.21708 6.15765 7.73231 6.53692 7.4379 7.05523L6.3009 9.04947C5.6859 10.1287 6.0459 11.5058 7.1019 12.1366C6.59323 12.4398 6.22353 12.9345 6.07347 13.5129C5.92341 14.0912 6.00517 14.7062 6.3009 15.2237L7.4379 17.2195C8.0529 18.2987 9.4089 18.6711 10.4769 18.06C10.4859 18.9994 11.0589 19.8035 11.8689 20.1394C11.8644 19.2715 12.0789 18.3914 12.5394 17.5858L12.6414 17.4064C12.5467 17.0771 12.3795 16.7737 12.1525 16.5192C11.9255 16.2647 11.6446 16.0656 11.3308 15.9369C11.0169 15.8082 10.6784 15.7532 10.3406 15.776C10.0028 15.7989 9.67454 15.899 9.3804 16.0688L8.2554 14.0944C9.7329 13.2188 9.7329 11.0544 8.2554 10.1788L9.3804 8.20435Z",
    fill: "url(#paint0_linear_75_6850)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8516 14.4166C14.4483 14.4166 15.0206 14.1764 15.4426 13.7488C15.8645 13.3212 16.1016 12.7413 16.1016 12.1366C16.1016 11.5319 15.8645 10.952 15.4426 10.5244C15.0206 10.0968 14.4483 9.85662 13.8516 9.85662C13.2548 9.85662 12.6825 10.0968 12.2606 10.5244C11.8386 10.952 11.6016 11.5319 11.6016 12.1366C11.6016 12.7413 11.8386 13.3212 12.2606 13.7488C12.6825 14.1764 13.2548 14.4166 13.8516 14.4166Z",
    fill: "url(#paint1_linear_75_6850)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4609 22.9675C20.4609 21.7319 20.9453 20.5469 21.8075 19.6732C22.6697 18.7995 23.8391 18.3087 25.0584 18.3087C26.2778 18.3087 27.4472 18.7995 28.3094 19.6732C29.1716 20.5469 29.6559 21.7319 29.6559 22.9675C29.6559 24.203 29.1716 25.388 28.3094 26.2617C27.4472 27.1354 26.2778 27.6263 25.0584 27.6263C23.8391 27.6263 22.6697 27.1354 21.8075 26.2617C20.9453 25.388 20.4609 24.203 20.4609 22.9675ZM25.0599 20.5902C24.7517 20.5902 24.4464 20.6517 24.1616 20.7713C23.8768 20.8908 23.618 21.066 23.4 21.2869C23.182 21.5078 23.0091 21.77 22.8911 22.0586C22.7732 22.3473 22.7124 22.6566 22.7124 22.969C22.7124 23.2814 22.7732 23.5907 22.8911 23.8793C23.0091 24.1679 23.182 24.4301 23.4 24.651C23.618 24.8719 23.8768 25.0472 24.1616 25.1667C24.4464 25.2862 24.7517 25.3478 25.0599 25.3478C25.6825 25.3478 26.2796 25.0972 26.7199 24.651C27.1601 24.2049 27.4074 23.5999 27.4074 22.969C27.4074 22.3381 27.1601 21.733 26.7199 21.2869C26.2796 20.8408 25.6825 20.5902 25.0599 20.5902Z",
    fill: "url(#paint2_linear_75_6850)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_75_6850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4872 27.2134C14.3064 26.8965 14.189 26.5466 14.1418 26.1836C14.0945 25.8207 14.1183 25.4519 14.2118 25.0983C14.3053 24.7447 14.4666 24.4132 14.6865 24.1228C14.9065 23.8324 15.1808 23.5888 15.4937 23.4058C15.5694 23.3613 15.6322 23.2975 15.6758 23.2206C15.7195 23.1438 15.7424 23.0567 15.7424 22.9681C15.7424 22.8794 15.7195 22.7923 15.6758 22.7155C15.6322 22.6387 15.5694 22.5748 15.4937 22.5303C14.8624 22.1606 14.4018 21.5519 14.2134 20.8382C14.0249 20.1244 14.1239 19.364 14.4887 18.7242L16.1477 15.8119C16.5125 15.1726 17.1129 14.7062 17.8169 14.5152C18.5209 14.3243 19.271 14.4244 19.9022 14.7935C19.978 14.8382 20.0641 14.8618 20.1518 14.862C20.2395 14.8622 20.3257 14.8389 20.4016 14.7944C20.4776 14.75 20.5406 14.686 20.5844 14.609C20.6281 14.532 20.651 14.4446 20.6507 14.3557C20.6507 12.8175 21.8807 11.5696 23.3987 11.5696H26.7182C28.2377 11.5696 29.4677 12.8175 29.4677 14.3557C29.4677 14.7449 29.8832 14.9881 30.2147 14.7935C30.5271 14.6101 30.8721 14.491 31.23 14.4429C31.5879 14.3949 31.9517 14.4188 32.3004 14.5134C32.6492 14.608 32.9761 14.7714 33.2625 14.9942C33.5488 15.217 33.789 15.4949 33.9692 15.8119L35.6297 18.7273C35.8104 19.0438 35.9278 19.3933 35.9751 19.7558C36.0224 20.1183 35.9987 20.4867 35.9054 20.84C35.812 21.1932 35.6509 21.5243 35.4311 21.8143C35.2114 22.1044 34.9373 22.3477 34.6247 22.5303C34.5487 22.5745 34.4855 22.6382 34.4415 22.7151C34.3976 22.792 34.3744 22.8792 34.3744 22.9681C34.3744 23.0569 34.3976 23.1442 34.4415 23.221C34.4855 23.2979 34.5487 23.3616 34.6247 23.4058C35.2556 23.7755 35.7159 24.3839 35.9043 25.0973C36.0927 25.8107 35.994 26.5707 35.6297 27.2104L33.9722 30.1227C33.7917 30.4396 33.5513 30.7173 33.2649 30.9401C32.9784 31.1629 32.6514 31.3263 32.3027 31.421C31.9539 31.5157 31.5901 31.5398 31.2321 31.4921C30.8741 31.4443 30.5289 31.3256 30.2162 31.1426C30.1403 31.098 30.0541 31.0745 29.9664 31.0744C29.8786 31.0743 29.7924 31.0976 29.7164 31.1419C29.6404 31.1863 29.5772 31.2502 29.5333 31.3272C29.4894 31.4041 29.4662 31.4915 29.4662 31.5804C29.4662 33.1201 28.2362 34.3665 26.7182 34.3665H23.4002C22.6712 34.3665 21.9721 34.0732 21.4565 33.551C20.941 33.0289 20.6511 32.3206 20.6507 31.5819C20.6507 31.493 20.6275 31.4057 20.5836 31.3287C20.5397 31.2517 20.4765 31.1878 20.4005 31.1435C20.3245 31.0991 20.2383 31.0758 20.1505 31.0759C20.0628 31.076 19.9766 31.0996 19.9007 31.1441C19.2693 31.5132 18.5191 31.613 17.8151 31.4218C17.1111 31.2305 16.5108 30.7638 16.1462 30.1242L14.4872 27.2134ZM16.6187 25.3803C16.5617 25.4135 16.5117 25.4578 16.4716 25.5107C16.4315 25.5636 16.4021 25.6239 16.3851 25.6883C16.3681 25.7527 16.3638 25.8199 16.3725 25.886C16.3812 25.9521 16.4026 26.0158 16.4357 26.0734L18.0947 28.9842C18.2327 29.2274 18.5372 29.3095 18.7772 29.1697C20.6087 28.0981 22.9007 29.4372 22.9007 31.5819C22.9007 31.8601 23.1242 32.0865 23.4002 32.0865H26.7182C26.8507 32.0865 26.9777 32.0332 27.0714 31.9383C27.1651 31.8434 27.2177 31.7146 27.2177 31.5804C27.2177 29.4372 29.5082 28.0965 31.3412 29.1681C31.5812 29.308 31.8857 29.2244 32.0237 28.9827L33.6827 26.0704C33.7485 25.9542 33.7662 25.8164 33.7319 25.687C33.6976 25.5577 33.6141 25.4474 33.4997 25.3803C31.6682 24.3087 31.6667 21.6289 33.4997 20.5558C33.5565 20.5229 33.6062 20.4789 33.6461 20.4264C33.686 20.3739 33.7152 20.3139 33.7321 20.2499C33.749 20.1859 33.7532 20.1191 33.7444 20.0534C33.7357 19.9877 33.7142 19.9245 33.6812 19.8673L32.0207 16.9534C31.9884 16.8956 31.945 16.8448 31.8931 16.8041C31.8412 16.7634 31.7819 16.7336 31.7185 16.7163C31.6551 16.699 31.589 16.6947 31.524 16.7036C31.4589 16.7125 31.3963 16.7344 31.3397 16.768C29.5082 17.8411 27.2177 16.4989 27.2177 14.3557C27.2177 14.2215 27.1651 14.0928 27.0714 13.9978C26.9777 13.9029 26.8507 13.8496 26.7182 13.8496H23.4002C23.3346 13.8492 23.2695 13.862 23.2088 13.8873C23.1481 13.9126 23.093 13.9499 23.0466 13.997C23.0003 14.0441 22.9637 14.1001 22.9389 14.1617C22.9141 14.2233 22.9016 14.2892 22.9022 14.3557C22.9022 16.4989 20.6117 17.8396 18.7787 16.7665C18.6641 16.6998 18.528 16.6819 18.4004 16.7166C18.2727 16.7514 18.1639 16.836 18.0977 16.9519L16.4387 19.8642C16.4059 19.9218 16.3846 19.9854 16.376 20.0513C16.3675 20.1172 16.3718 20.1842 16.3888 20.2484C16.4058 20.3127 16.4351 20.3729 16.4751 20.4256C16.515 20.4784 16.5649 20.5226 16.6217 20.5558C18.4547 21.6274 18.4517 24.3102 16.6217 25.3803",
    fill: "url(#paint3_linear_75_6850)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_6850",
    x: 0.666667,
    y: 3.96811,
    width: 26.2497,
    height: 26.8379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_6850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_6850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_75_6850",
    x: 8.78483,
    y: 11.5696,
    width: 32.5473,
    height: 33.4636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_6850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_6850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6850",
    x1: 18.6535,
    y1: 68.0896,
    x2: 2.14431,
    y2: 67.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7928CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6850",
    x1: 15.2556,
    y1: 27.9377,
    x2: 10.489,
    y2: 27.6395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7928CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6850",
    x1: 27.9274,
    y1: 55.2543,
    x2: 18.1876,
    y2: 54.6449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7928CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6850",
    x1: 31.8856,
    y1: 101.963,
    x2: 8.70354,
    y2: 100.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7928CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceIcon01);
export default __webpack_public_path__ + "static/media/advanceIcon01.66a2937b46ae34a455d5c3d93d80fae4.svg";
export { ForwardRef as ReactComponent };